export const OpenDcCampaignType = {
    display: "DISPLAY",
    video: "VIDEO",
    socialVideo: "SOCIAL_VIDEO",
    socialStatic: "SOCIAL_STATIC",
    tiktokVideo: "TIKTOK_VIDEO",
} as const;
